// removed by extract-text-webpack-plugin
module.exports = {"root":"LatestStories__root--KB2wG","heading":"LatestStories__heading--i1xKm","hiddenLarge":"LatestStories__hiddenLarge--Qy-p3","hiddenSmall":"LatestStories__hiddenSmall--3PbmY","bounce":"LatestStories__bounce--3rQ7Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/LatestStories/LatestStories.css
// module id = ./src/components/Library/LatestStories/LatestStories.css
// module chunks = 1